import React from 'react';
import { Typography, Divider, Chip } from '@mui/material'; // Removed Paper
import GlassCard from '../../../ui/glass/components/GlassCard';

const CustomerInfoCard = ({ customer }) => {
    return (
        <GlassCard sx={{ p: 2 }}>
            <Typography variant="h6">İletişim Bilgileri</Typography>
            <Divider sx={{ my: 1 }} />
            <Typography><b>TC Kimlik No:</b> {customer.tcKimlikNo || '-'}</Typography>
            <Typography><b>Telefon:</b> {customer.telefon}</Typography>
            <Typography><b>E-posta:</b> {customer.email || '-'}</Typography>
            <Typography><b>Adres:</b> {customer.adres || '-'}</Typography>
            <Divider sx={{ my: 1 }} />
            <Typography component="div" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <b>Hizmet Türü:</b>
                {customer.hizmetTuru ? (
                    (Array.isArray(customer.hizmetTuru) ? customer.hizmetTuru : [customer.hizmetTuru]).map((tur, idx) => (
                        <Chip key={idx} label={tur} size="small" variant="outlined" />
                    ))
                ) : '-'}
            </Typography>
        </GlassCard>
    );
};

export default CustomerInfoCard;
